import React, { Component } from "react";
import styled, { withTheme } from "styled-components";
import { ocean } from "@vitalsource/vstui/colors";
import { Dialog, TextField } from "@vitalsource/vstui";
import Dispatcher from "../../dispatcher";
import BookStore from "../../stores/book-store";

const CommentTypes = styled.fieldset`
  border: none;
  padding-left: 0;
  padding-right: 0;
`;

const CheckboxItem = styled.li`
  display: inline-flex;
  margin-left: 4px;
  padding-bottom: 6px;
  input[type="checkbox"]:focus + label {
    border: 1px solid ${ocean.getShade(8)};
  }
  label {
    background-color: ${props => props.theme.color.primary.getShade(1)};
    border: 1px solid ${props => props.theme.color.primary.getShade(2)};
    border-radius: 26.5px;
    padding: 7px 12px;
    cursor: pointer;
    &.checked {
      background-color: ${props => props.theme.color.primary.getShade(2)};
      border-color: ${props => props.theme.color.primary.getShade(3)};
    }
  }
`;
const Checkboxes = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
`;
const Checkbox = ({ checked, labelText, id, onChange }) => (
  <CheckboxItem>
    <input
      id={id}
      className="no-checkbox"
      checked={checked}
      onChange={onChange}
      type="checkbox"
      value={id}
    />
    <label htmlFor={id} className={checked ? "checked" : "unchecked"}>
      {i18n.t(labelText)}
    </label>
  </CheckboxItem>
);

const checkboxLabels = [
  { key: "margin", fallback: "Margin" },
  { key: "line-height", fallback: "Line height" },
  { key: "text-size", fallback: "Text size" },
  { key: "mode", fallback: "Mode" },
  { key: "unreadable-text", fallback: "Unreadable text" },
  { key: "overlapping-text", fallback: "Overlapping text and image" }
];

class Feedback extends Component {
  constructor() {
    super();
    const defaultState = checkboxLabels.reduce((acc, label) => {
      acc[label.key] = false;
      return acc;
    }, {});

    this.state = defaultState;

    this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
    this.handleFeedbackChange = this.handleFeedbackChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  handleFeedbackChange(e) {
    const { value } = e.currentTarget;
    this.setState({
      feedback: value
    });
  }

  handleCheckboxChange(e) {
    const key = e.currentTarget.value;
    this.setState(prevState => ({
      [key]: !prevState[key]
    }));
  }

  close() {
    Dispatcher.emit(Dispatcher.CLOSE_MODAL, "enhanced-formatting-feedback");
  }

  onSubmit(e) {
    e.preventDefault();
    const relatedTo = checkboxLabels.reduce((acc, label) => {
      if (this.state[label.key]) {
        acc.push(`entry.2018104913=${encodeURIComponent(label.fallback)}`);
      }
      return acc;
    }, []);

    const book = BookStore.get(this.props.isbn);

    $.ajax({
      url:
        "https://docs.google.com/forms/d/e/1FAIpQLSfqQzxYbrvtJQgVSVX7L2KEH_d2o4PEQIXYhUbTEVysMbKV5Q/formResponse",
      type: "POST",
      data:
        `entry.1447400929=${encodeURIComponent(navigator.userAgent)}&` +
        `entry.1770075581=${encodeURIComponent(Fraction.Brand.name)}&` +
        `entry.1846329814=${encodeURIComponent(book.isbn)}&` +
        `entry.2043734216=${encodeURIComponent(`${book.pageCFI}!${book.lastCFI}`)}&` +
        "entry.2018104913_sentinel&" +
        relatedTo.join("&") +
        "&entry.1001003220=" +
        encodeURIComponent(this.state.feedback)
    });
    this.close();
  }

  render() {
    return (
      <Dialog
        open
        darkHeader
        key="FeedbackModal"
        rootSelector="#bookshelf"
        size="medium"
        onRequestClose={this.close}
        title={i18n.t("enhanced-formatting.feedback.something-not-look-right")}
        formProps={{ onSubmit: this.onSubmit }}
        primaryActionButton={{ label: i18n.t("base.submit") }}
        secondaryActionButton={{
          label: i18n.t("base.cancel"),
          onClick: this.close
        }}
      >
        <div className="legacy-checkboxes">
          <TextField
            fullWidth
            label={i18n.t("enhanced-formatting.feedback.describe")}
            labelHidden
            multiline
            placeholder={i18n.t("enhanced-formatting.feedback.describe")}
            required
            rows={3}
            name="feedback"
            onChange={this.handleFeedbackChange}
          />
          <CommentTypes>
            <legend>
              {i18n.t("enhanced-formatting.feedback.select-the-types")}
            </legend>
            <Checkboxes>
              {checkboxLabels.map(({ key }) => (
                <Checkbox
                  key={key}
                  checked={this.state[key]}
                  labelText={`enhanced-formatting.feedback.${key}`}
                  id={key}
                  name={key}
                  onChange={this.handleCheckboxChange}
                />
              ))}
            </Checkboxes>
          </CommentTypes>
        </div>
      </Dialog>
    );
  }
}


export default withTheme(Feedback);
